import React, { useState, useEffect } from "react";
import apiService from "../../services/api";
import "../../styles/global.css";
import "./AdminRestaurantView.css";
import { useNavigate } from "react-router-dom";

export default function AdminRestaurantView() {
  const navigate = useNavigate();

  // ==============================
  // STATES
  // ==============================

  const [restaurants, setRestaurants] = useState([]);
  const [restaurantId, setRestaurantId] = useState("");
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);

  const [newItem, setNewItem] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    image: null,
    model: null,
  });

  // ==============================
  // LOAD ALL RESTAURANTS ON PAGE LOAD
  // ==============================
useEffect(() => {
  const role = localStorage.getItem("userRole");

  if (role === "admin") {
    fetchAllRestaurants();
  } else {
    console.log("User is not admin");
  }
}, []);


  const fetchAllRestaurants = async () => {
    try {
      console.log("Fetching all restaurants...");

      const data = await apiService.getAllRestaurants();

      console.log("All restaurants:", data);

      setRestaurants(data);
    } catch (error) {
      console.error(error);
    }
  };

  // ==============================
  // FETCH SINGLE RESTAURANT
  // ==============================

  const fetchRestaurant = async () => {
    console.log("========== FETCH START ==========");
    console.log("Entered Restaurant ID:", restaurantId);

    if (!restaurantId) {
      console.warn("Restaurant ID is empty");
      setError("Please enter Restaurant ID");
      return;
    }

    try {
      setLoading(true);
      setError("");

      console.log(`GET Request → /api/restaurants/${restaurantId}`);

      const data = await apiService.getRestaurantDetails(
        restaurantId
      );

      console.log("API Response received:");
      console.log(data);

      if (!data) {
        console.warn("No data returned from API");
        setError("Restaurant not found");
        setRestaurant(null);
        return;
      }

      setRestaurant(data);

      console.log("Restaurant state updated successfully");
    } catch (err) {
      console.error("Error fetching restaurant:", err.message);

      setError("Restaurant not found");
      setRestaurant(null);
    } finally {
      setLoading(false);

      console.log("Loading finished");
      console.log("========== FETCH END ==========");
    }
  };

  // ==============================
  // FETCH RESTAURANT BY CLICK
  // ==============================

  const fetchRestaurantById = async (id) => {
    try {
      setLoading(true);

      const data = await apiService.getRestaurantDetails(id);

      setRestaurant(data);

      setRestaurantId(id);
    } catch (err) {
      console.error(err);
      setError("Restaurant not found");
      setRestaurant(null);
    } finally {
      setLoading(false);
    }
  };

  // ==============================
  // ADD FOOD ITEM FUNCTIONALITY
  // ==============================

  const handleAddItem = async () => {
    try {
      console.log("Adding new item...");

      const formData = new FormData();

      formData.append("name", newItem.name);
      formData.append("description", newItem.description);
      formData.append("price", newItem.price);
      formData.append("category", newItem.category);

      if (newItem.image) {
        formData.append("image", newItem.image);
      }

      if (newItem.model) {
        formData.append("model", newItem.model);
      }

      await apiService.addRestaurantItem(
        restaurantId,
        formData
      );

      console.log("Item added successfully");

      alert("Food item added successfully");

      setShowAddForm(false);

      setNewItem({
        name: "",
        description: "",
        price: "",
        category: "",
        image: null,
        model: null,
      });

      fetchRestaurant();
    } catch (error) {
      console.error(error);
      alert("Failed to add item");
    }
  };

  // ==============================
  // BACK TO LIST BUTTON
  // ==============================

  const handleBackToList = () => {
    setRestaurant(null);
    setRestaurantId("");
    setShowAddForm(false);
  };

  // ==============================
  // UI
  // ==============================

  return (
    <div className="section">
      <div className="container2">

        <h1 style={{ textAlign: "center" }}>
          🍽️ Admin Restaurant Details
        </h1>

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <button
            className="btn btn-success"
            onClick={() => navigate("/admin/create-restaurant")}
          >
            + Create New Restaurant
          </button>
        </div>

        {/* SEARCH INPUT */}

        <div className="form-group">
          <label>Restaurant ID</label>

          <input
            type="text"
            value={restaurantId}
            onChange={(e) => {
              console.log(
                "Restaurant ID changed:",
                e.target.value
              );

              setRestaurantId(e.target.value);
            }}
            className="form-input"
            placeholder="Enter Restaurant ID"
          />
        </div>

        <button
          onClick={fetchRestaurant}
          className="btn btn-primary"
          style={{ marginBottom: "20px" }}
        >
          {loading ? "Loading..." : "Get Details"}
        </button>

        {/* SHOW ALL RESTAURANTS ONLY IF NO RESTAURANT SELECTED */}

        {!restaurant && restaurants.length > 0 && (
          <div className="all-restaurants">
            <h3>All Restaurants</h3>

            <div className="restaurant-grid">
              {restaurants.map((res) => (
                <div
                  key={res.id}
                  className="restaurant-card"
                  onClick={() => {
                    setRestaurantId(res.id);
                    fetchRestaurantById(res.id);
                  }}
                >
                  <h4>{res.restaurantName}</h4>

                  <p>{res.restaurantAddress}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {error && (
          <div className="error-message">{error}</div>
        )}

        {/* RESTAURANT DETAILS */}

        {restaurant && (
          <div className="card2">

            <button
              className="btn btn-secondary"
              style={{ marginBottom: "15px" }}
              onClick={handleBackToList}
            >
              ← Back to Restaurants
            </button>

            <div>
              <h2 className="restaurant-title">
                {restaurant.restaurantName}
              </h2>

              <p className="restaurant-address">
                📍 {restaurant.restaurantAddress}
              </p>
            </div>

            {restaurant.qrUrl && (
              <div className="qr-section">
                <h3>QR Code</h3>

                <img
                  src={restaurant.qrUrl}
                  alt="QR"
                  className="qr-image"
                />
              </div>
            )}

            {restaurant.menuUrl && (
              <div className="menu-url">
                <span>🔗 Menu URL:</span>

                <a
                  href={restaurant.menuUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  {restaurant.menuUrl}
                </a>
              </div>
            )}

            {/* FOOD ITEMS HEADER */}

            <div className="items-header">
              <h3>Food Items</h3>

              <button
                className="add-item-btn"
                onClick={() => setShowAddForm(true)}
              >
                + Add Food Item
              </button>
            </div>

            <div className="restaurant-container">
              <div className="food-section">

                <div className="section-header">
                  <h3>Your trusted picks</h3>
                  <span className="view-all">View all</span>
                </div>

                <div className="food-grid">
                  {restaurant.items?.map((item) => (
                    <div
                      key={item.itemId}
                      className="food-card"
                      onClick={() =>
                        navigate(
                          `/admin/item/${restaurantId}/${item.itemId}`
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={item.imageUrl}
                        alt={item.name}
                        className="food-image"
                      />

                      <div className="food-body">
                        <h4 className="food-name">
                          {item.name}
                        </h4>

                        <p className="food-desc">
                          {item.description || "Delicious"}
                        </p>

                        <p className="food-price">
                          ₹{item.price}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </div>
        )}

        {/* ADD FOOD ITEM FORM */}

        {showAddForm && (
          <div className="add-form">

            <h3>Add New Food Item</h3>

            <input
              type="text"
              placeholder="Food Name"
              className="form-input"
              value={newItem.name}
              onChange={(e) =>
                setNewItem({
                  ...newItem,
                  name: e.target.value,
                })
              }
            />

            <textarea
              placeholder="Description"
              className="form-input"
              value={newItem.description}
              onChange={(e) =>
                setNewItem({
                  ...newItem,
                  description: e.target.value,
                })
              }
            />

            <input
              type="number"
              placeholder="Price"
              className="form-input"
              value={newItem.price}
              onChange={(e) =>
                setNewItem({
                  ...newItem,
                  price: e.target.value,
                })
              }
            />

            <select
              className="form-input"
              value={newItem.category}
              onChange={(e) =>
                setNewItem({
                  ...newItem,
                  category: e.target.value,
                })
              }
            >
              <option value="">Select Category</option>
              <option value="Starters">Starters</option>
              <option value="Main Course">Main Course</option>
              <option value="Biryani">Biryani</option>
              <option value="Drinks">Drinks</option>
              <option value="Desserts">Desserts</option>
            </select>

            <input
              type="file"
              accept="image/*"
              className="form-input"
              onChange={(e) =>
                setNewItem({
                  ...newItem,
                  image: e.target.files[0],
                })
              }
            />

            <input
              type="file"
              accept=".glb,.gltf"
              className="form-input"
              onChange={(e) =>
                setNewItem({
                  ...newItem,
                  model: e.target.files[0],
                })
              }
            />

            <div className="form-buttons">

              <button
                className="btn btn-primary"
                onClick={handleAddItem}
              >
                Save Item
              </button>

              <button
                className="btn btn-secondary"
                onClick={() => setShowAddForm(false)}
              >
                Cancel
              </button>

            </div>

          </div>
        )}

      </div>
    </div>
  );
}
